import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { handleError } from 'utils/helper';

export const loadTranslation = async (langCode) => {
  try {
    const translation = await import(`locales/${langCode}.json`);
    return translation.default;
  } catch (error) {
    handleError(error);
    return {};
  }
};

export const initI18n = async (langCode) => {
  const translation = await loadTranslation(langCode);

  await i18n.use(initReactI18next).init({
    resources: {
      [langCode]: { translation },
    },
    lng: langCode,
    fallbackLng: langCode,
    debug: process.env.NODE_ENV === 'development',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
};
